import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42788c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "TableBox"
}
const _hoisted_2 = { class: "TableTop" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_8 = { class: "TableTopBtn" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已删除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = { class: "tableBottom" }
const _hoisted_15 = {
  key: 0,
  class: "sortingBox"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("排序")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-列表'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form, {
              model: _ctx.query,
              inline: "",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "问题名称：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.query.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
                      placeholder: "请输入问题名称",
                      size: "small",
                      clearable: "",
                      onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList('place')))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "状态：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.query.status,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.status) = $event)),
                      size: "small",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList('place'))),
                      style: {"display":"block"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_button, { label: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: 2 }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getList('place')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.init()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.projectStatus !== 1 && _ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-新增'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    icon: "plus",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onAddOrEdit(0)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            ref: "tableListRef",
            class: "TableList",
            border: "",
            data: _ctx.list,
            "max-height": "800"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "问题名称",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "answer",
                label: "问题描述",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "创建时间",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "sort",
                label: "排序",
                align: "center",
                sortable: "",
                width: "130"
              }, {
                default: _withCtx((scope) => [
                  (_ctx.ifSorting)
                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 0,
                        modelValue: scope.row.newSorting,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.newSorting) = $event),
                        min: 0,
                        size: "mini",
                        style: {"width":"100px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(scope.row.sort), 1)
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "状态",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status === 0)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_switch, {
                        key: 1,
                        disabled: !_ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-显示/隐藏'),
                        modelValue: scope.row.status,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event),
                        "active-value": 1,
                        "inactive-value": 2,
                        onChange: ($event: any) => (_ctx.editStatus(scope.row)),
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center",
                width: "260",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  (_ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-详情'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "mini",
                        onClick: ($event: any) => (_ctx.onAddOrEdit(2, scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-编辑'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        size: "mini",
                        onClick: ($event: any) => (_ctx.onAddOrEdit(1, scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-删除'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "danger",
                        size: "mini",
                        onClick: ($event: any) => (_ctx.onDel(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.list.length > 0 && _ctx.$globalFun.ifAuth(_ctx.$route, '热门问题-排序'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (!_ctx.ifSorting)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        onClick: _ctx.onSortingShow
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: _ctx.onSortingSave
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ifSorting = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.ifSorting)
              ? (_openBlock(), _createBlock(_component_el_pagination, {
                  key: 1,
                  background: "",
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange,
                  "current-page": _ctx.query.page,
                  "page-sizes": [20, 40, 60, 100],
                  "page-size": _ctx.query.paginate,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.total
                }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无权限"
        }))
  ]))
}